/* ============================================================
   hero-banner.js — Maskaľ (Sleek theme compatible)
   ------------------------------------------------------------
   JS-driven slideshow: zvlada lubovolny pocet obrazkov (1–6).
   CSS robi zoom animaciu; JS rozhoduje kedy prepnut obraz.
   Pouziva prefix `mskl-hero-banner-*` aby nezasahoval do Sleeku.
   ============================================================ */

(function () {
  'use strict';

  const SELECTOR = '.mskl-hero-banner';
  const banners = new Map();

  function initBanner(banner) {
    if (!banner || banner.dataset.heroInit === '1') return;
    banner.dataset.heroInit = '1';

    const imgs = Array.from(banner.querySelectorAll('.mskl-hero-banner__img'));
    if (imgs.length === 0) return;

    /* --- Cycle config --- */
    const cycleSec = parseFloat(banner.dataset.cycle) || 16;
    const cycleMs = cycleSec * 1000;
    const perImageMs = cycleMs / imgs.length;

    /* Per-image time pre CSS zoom animaciu */
    imgs.forEach((img) => {
      img.style.setProperty('--mskl-per-image-time', `${perImageMs}ms`);
    });

    /* Pre-decode vsetky obrazky aby pri prvom strihu nebol preblik
       (browser inak dekoduje az v momente ked image stane viditelnym). */
    imgs.forEach((img) => {
      if (typeof img.decode === 'function') {
        img.decode().catch(() => { /* ignore — image may still load via natural flow */ });
      }
    });

    /* Image error fallback */
    imgs.forEach((img) => {
      img.addEventListener('error', () => {
        img.style.display = 'none';
      });
    });

    /* Analytics hook na link */
    const link = banner.querySelector('.mskl-hero-banner__link');
    if (link) {
      link.addEventListener('click', () => {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'hero_link_click',
            link_label: link.textContent.trim(),
            link_url: link.getAttribute('href'),
          });
        }
      });
    }

    /* Single image / static / reduced motion: bez rotacie */
    if (
      imgs.length <= 1 ||
      banner.classList.contains('mskl-hero-banner--static') ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    /* --- Rotation logic --- */
    let current = 0;

    function next() {
      imgs[current].classList.remove('is-active');
      current = (current + 1) % imgs.length;
      imgs[current].classList.add('is-active');
    }

    const state = {
      current,
      imgs,
      perImageMs,
      timer: setInterval(next, perImageMs),
      next,
    };
    banners.set(banner, state);
  }

  function destroyBanner(banner) {
    const state = banners.get(banner);
    if (state) {
      clearInterval(state.timer);
      banners.delete(banner);
    }
    banner.dataset.heroInit = '';
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initBanner);
  }

  /* --- Initial run --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* --- Pause na hidden tab + force-restart pri navrate ---
     Bez force-restartu by animacia mohla zostat "zaseknuta" v pauznutom
     stave (browser quirk pri dlhsom hidden state). Pri navrate explicitne:
     1) vycistime `is-active` zo vsetkych obrazkov (defensiva)
     2) force reflow (aby browser vyhodnotil class removal/add ako diskretne)
     3) re-pridame `is-active` na current image -> CSS animacia restartne
     4) restartneme rotation timer */
  document.addEventListener('visibilitychange', () => {
    banners.forEach((state, banner) => {
      if (document.hidden) {
        clearInterval(state.timer);
        state.timer = null;
        banner.classList.add('is-paused');
      } else if (!state.timer) {
        banner.classList.remove('is-paused');
        const currentImg = state.imgs[state.current];
        state.imgs.forEach((img) => img.classList.remove('is-active'));
        /* eslint-disable-next-line no-unused-expressions */
        currentImg.offsetWidth; /* force reflow */
        currentImg.classList.add('is-active');
        state.timer = setInterval(state.next, state.perImageMs);
      }
    });
  });

  /* --- Shopify theme editor support --- */
  document.addEventListener('shopify:section:load', (event) => {
    const banner = event.target.querySelector(SELECTOR);
    if (banner) initBanner(banner);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const banner = event.target.querySelector(SELECTOR);
    if (banner) destroyBanner(banner);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const banner = event.target.closest(SELECTOR);
    const state = banners.get(banner);
    if (!state) return;
    const targetIndex = parseInt(event.target.dataset.index, 10);
    if (Number.isNaN(targetIndex)) return;

    clearInterval(state.timer);
    state.timer = null;
    state.imgs.forEach((img, i) => {
      img.classList.toggle('is-active', i === targetIndex);
    });
    state.current = targetIndex;
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const banner = event.target.closest(SELECTOR);
    const state = banners.get(banner);
    if (!state) return;
    if (!state.timer) {
      state.timer = setInterval(state.next, state.perImageMs);
    }
  });
})();